import { NumberUtils } from '@atlassian/mpac-utils';
export var validateDiscount = function validateDiscount(value) {
  if (!value) {
    return 'Discount percentage is required.';
  }

  if (value % 1 !== 0) {
    return 'You can only enter numeric characters';
  }
};
export var onChangeFlatDiscount = function onChangeFlatDiscount(value, setFieldValue) {
  var flatDiscount = Number(value);
  value = flatDiscount === 0 ? '' : NumberUtils.bindNumberInRange(flatDiscount, 1, 100).toString();
  setFieldValue('discountPercent', value);
};